import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ComponentsModule } from '@core/components';
import { SharedModule } from '@core/shared.module';

import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ServerErrorComponent } from './server-error/server-error.component';

const components = [AccessDeniedComponent, PageNotFoundComponent, ServerErrorComponent];

@NgModule({
  declarations: components,
  imports: [ComponentsModule, CommonModule, SharedModule],
  exports: components,
})
export class PagesModule {}
